<template>
  <div class="flex flex-col h-full" v-if="techMap">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-semibold">
      Спецификация на {{ techMap?.product?.name }}
    </h2>
      <div class="flex space-x-2">
        
      </div>
    </div>

    <div class="flex">
      <!-- Левая колонка (структура изделия) -->
      <div class="w-1/2 border-r border-gray-200 overflow-y-auto p-4">
        <div class="flex items-center space-x-2 mb-2">
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Поиск..."
            class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <ul>
          <TreeNode
            v-for="(component, index) in filteredProducts"
            :key="`product-${index}`"
            :node="component"
            @viewDetailMaterial="viewDetailMaterial"
          />
          <TreeNode
            v-for="(component, index) in filteredTechnologies"
            :key="`technology-${index}`"
            :node="component"
            @viewDetailTechnology="viewDetailTechnology"
            @viewDetailOperation="viewDetailOperation"
          />
        </ul>
      </div>
      <!-- Правая колонка (форма редактирования) -->
      <div class="w-1/2 p-4">

      </div>
    </div>
  </div>
</template>

<script>
import TreeNode from "@/components/production/TreeNode.vue";
import Specifications from "@/components/production/TechMaps.vue";
import MaterialTab from "@/components/production/techMaps/MaterialTabComponent.vue";
import ViewDetailMaterial from "@/components/production/techMaps/ViewDetailMaterialComponent.vue";
import ViewDetailTechnology from "@/components/production/techMaps/ViewDetailTechnologyComponent.vue";
import ViewDetailOperation from "@/components/production/techMaps/ViewDetailOperationComponent.vue";
import TechnologyTab from "@/components/production/techMaps/TechnologyTabComponent.vue";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import axios from 'axios';

export default {
  components: {
    TechnologyTab,
    ViewDetailMaterial,
    MaterialTab,
    ViewDetailTechnology,
    ViewDetailOperation,
    Specifications,
    TreeNode,
    vSelect,
  },
  data() {
    return {
      techMap: null,
      originalTechMap: null, // Для хранения исходной копии техкарты
      products: [],
      selectedProduct: null,
      selectedTechnology: null,
      selectedOperation: null,
      technologies: [],
      activeTab: "tab1",
      activeComponent: null,
      searchQuery: '',
      addMenuSearchQuery: '',
      tabs: [
        { label: "Материалы", name: "tab1" },
        { label: "Технология", name: "tab2" },
      ],
      addChildOptions: [
        { label: 'Продукт', value: 'material' },
        { label: 'Технология', value: 'technology' },
        { label: 'Операция', value: 'operation' },
      ],
      selectedChildOption: null,
      isModalOpen: false,
      newItemName: '',
      selectedTechnologyForOperation: null,
      selectedWorkshopPost: null,
      apiProducts: [],
      workshopPosts: [],
      addProductError: '',
      isLoadingProducts: false, // Флаг загрузки продуктов
      isSaving: false, // Флаг для блокировки сохранения
      hasUnsavedChanges: false, // Флаг для отслеживания изменений
      localIdCounter: 0, // Счетчик для генерации временных ID

      // Модальные окна подтверждения
      isSaveConfirmModalOpen: false,
      isCancelConfirmModalOpen: false,
      productSearchTimer: null
    };
  },
  computed: {
    filteredProducts() {
      if (!this.searchQuery) {
        return this.products;
      }
      return this.products.filter(product => {
        return this.containsSearchTerm(product);
      });
    },
    filteredTechnologies() {
      if (!this.searchQuery) {
        return this.technologies;
      }
      return this.technologies.filter(technology => {
        return this.containsSearchTerm(technology);
      });
    },
    technologyOptions() {
      return this.technologies.map(tech => ({
        label: tech.technology.name,
        value: tech.technology_id || tech.technology.id
      }));
    },
    productOptions() {
      if (this.apiProducts.length === 0) {
        return [];
      }
      
      return this.apiProducts.map((item) => {
        // Извлекаем SKU из value.sku если доступен, иначе из sku
        const sku = (item.value && item.value.sku) ? item.value.sku : (item.sku || '');
        const name = (item.value && item.value.name) ? item.value.name : (item.name || '');
        const id = (item.value && item.value.id) ? item.value.id : (item.id || 0);
        
        const label = sku ? `${sku} - ${name}` : name;
        
        return {
          id: id,
          name: name,
          sku: sku,
          label: label,
          value: item.value || item
        };
      });
    },
    workshopPostOptions() {
      return this.workshopPosts ? this.workshopPosts.map(post => ({
        id: post.id,
        name: post.name
      })) : [];
    }
  },
  async mounted() {
    this.apiProducts = [];
    await this.getTechMap();
  },
  methods: {
    // Генерирует уникальный локальный ID
    generateLocalId() {
      this.localIdCounter++;
      return `local-${this.localIdCounter}`;
    },

    async getProducts() {
      this.onProductSearch('');
    },
    
    async reloadProducts() {
      this.apiProducts = [];
      this.onProductSearch('');
    },

    onProductSearch(search) {
      clearTimeout(this.productSearchTimer);
      this.productSearchTimer = setTimeout(async () => {
        this.isLoadingProducts = true;
        this.addProductError = '';
        try {
          const { data } = await axios.post('/api/product/getProducts', {
            page: 1,
            per_page: 50,
            search: search?.trim() || ''
          });
          const list = data?.data?.data || [];
          this.apiProducts = list;
        } catch (error) {
          console.error('Ошибка при получении продуктов:', error);
          this.apiProducts = [];
          this.addProductError = 'Ошибка при загрузке списка продуктов.';
        } finally {
          this.isLoadingProducts = false;
        }
      }, 350);
    },

    async getTechMap() {
      try {
        const { data } = await axios.post(`/api/techMap/getTechMap/${this.$route.params.id}`);
        this.techMap = data.techMap;
        // Создаем глубокую копию для отслеживания изменений
        this.originalTechMap = JSON.parse(JSON.stringify(data.techMap));
        this.workshopPosts = data.workshopPosts;
        this.products = this.techMap.components?.filter(el => el.type === 'product') || [];
        this.technologies = this.techMap.components?.filter(el => el.type === 'technology') || [];
      } catch (error) {
        console.error('Ошибка при получении спецификации:', error);
        alert('Ошибка при загрузке спецификации.');
      }
    },

    async addNewItem() {
      if (this.isSaving) return;

      this.isSaving = true;
      this.addProductError = '';

      let type = this.selectedChildOption;
      let techMapId = this.techMap.id;

      if (type === 'material') {
        if (!this.newItemName) {
          this.addProductError = 'Заполните все поля.';
          this.isSaving = false;
          return;
        }
        const productId = this.newItemName.value?.id ?? this.newItemName.id ?? this.newItemName.value;

        // Проверяем, существует ли уже такой продукт в списке
        const existingProduct = this.techMap.components.find(
          (component) => component.type === 'product' && component.product?.id === productId
        );
        if (existingProduct) {
          this.addProductError = 'Этот продукт уже добавлен.';
          this.isSaving = false;
          return;
        }

        const product = {
          id: productId,
          name: this.newItemName.name || this.newItemName.value?.name || ''
        };

        if (!this.techMap.components) {
          this.$set(this.techMap, 'components', []);
        }

        this.techMap.components.push({
          product: {
            id: product.id,
            name: product.name
          },
          product_id: product.id,
          count: 1,
          type: 'product'
        });
        this.products = this.techMap.components?.filter(el => el.type === 'product') || [];

      } else if (type === 'technology') {
        if (!this.newItemName) {
          this.addProductError = 'Заполните название технологии.';
          this.isSaving = false;
          return;
        }
        // Проверка на уникальность имени технологии
        const existingTechnology = this.techMap.components.find(
          (component) => component.type === 'technology' &&
          component.technology?.name?.toLowerCase().trim() === this.newItemName.toLowerCase().trim()
        );

        if (existingTechnology) {
          this.addProductError = 'Технология с таким названием уже существует.';
          this.isSaving = false;
          return;
        }

        const localId = this.generateLocalId();

        if (!this.techMap.components) {
          this.$set(this.techMap, 'components', []);
        }

        this.techMap.components.push({
          technology: {
            id: localId,
            name: this.newItemName.trim(),
            operations: []
          },
          technology_id: localId,
          type: 'technology'
        });

        this.technologies = this.techMap.components?.filter(el => el.type === 'technology') || [];

      } else if (type === 'operation') {
        // Ищем операцию по имени в рамках технологии или создаем новую
        if (!this.newItemName || !this.selectedWorkshopPost || !this.selectedTechnologyForOperation) {
          this.addProductError = 'Заполните все поля.';
          this.isSaving = false;
          return;
        }

        const technology = this.techMap.components.find(el =>
          el.type === 'technology' &&
          (el.technology_id === this.selectedTechnologyForOperation ||
           el.technology.id === this.selectedTechnologyForOperation)
        );

        // Проверяем, существует ли уже операция с таким именем в этой технологии
        const existingOperation = technology?.technology?.operations?.find(
          operation => operation.name?.toLowerCase().trim() === this.newItemName.toLowerCase().trim()
        );

        if (existingOperation) {
          this.addProductError = 'Операция с таким названием уже существует в этой технологии.';
          this.isSaving = false;
          return;
        }

        let maxSort = 0;
        if (technology?.technology?.operations && technology.technology.operations.length > 0) {
          maxSort = Math.max(...technology.technology.operations.map(op => op.sort || 0)) || 0;
        }
        const newSort = maxSort + 5;
        const localId = this.generateLocalId();

        if (!technology?.technology?.operations) {
          this.$set(technology.technology, 'operations', []);
        }

        const newOperation = {
          id: localId,
          name: this.newItemName.trim(),
          workshop_post_id: this.selectedWorkshopPost,
          sort: newSort,
          steps: [],
          technology_id: this.selectedTechnologyForOperation
        };

        technology.technology.operations.push(newOperation);
        technology.technology.operations.sort((a, b) => (a.sort || 0) - (b.sort || 0));
      }

      try {
        this.addProductError = ''; // Сброс ошибки перед отправкой
        this.hasUnsavedChanges = true;
        this.closeModal();
      } catch (error) {
        console.error('Ошибка при добавлении:', error);
        this.addProductError = error.response?.data?.message || 'Произошла ошибка при добавлении.';
      } finally {
        this.isSaving = false;
      }
    },

    async saveTechMap() {
      if (this.isSaving) return;

      this.isSaving = true;
      try {
        const response = await axios.post('/api/techMap/saveTechMap', this.techMap);
        this.hasUnsavedChanges = false;

        // Обновляем TechMap данными с сервера, чтобы получить реальные ID для локальных элементов
        if (response && response.data && response.data.techMap) {
          // Сохраняем текущее выбранное состояние, чтобы восстановить его после обновления данных
          const selectedTechId = this.selectedTechnology ? this.selectedTechnology.id : null;
          const selectedOpId = this.selectedOperation ? this.selectedOperation.id : null;

          this.techMap = response.data.techMap;

          // Восстанавливаем выбранную технологию и операцию
          if (selectedTechId) {
            this.selectedTechnology = this.techMap.components.find(c => c.id === selectedTechId);

            if (this.selectedTechnology && selectedOpId && this.selectedTechnology.technology) {
              this.selectedOperation = this.selectedTechnology.technology.operations.find(
                op => op.id === selectedOpId
              );
            }
          }
        } else {
          // Если сервер не вернул обновленные данные, запрашиваем их отдельно
          await this.getTechMap();
        }

        // Обновляем оригинальную копию после сохранения
        this.originalTechMap = JSON.parse(JSON.stringify(this.techMap));

        // Проверяем, доступен ли сервис уведомлений
        if (this.$toast && typeof this.$toast.success === 'function') {
          this.$toast.success('Спецификация успешно сохранена');
        } else {
          console.log('Спецификация успешно сохранена');
        }
      } catch (error) {
        console.error('Error saving tech map:', error);
        let errorMsg = 'Ошибка при сохранении спецификации';

        if (error && error.response && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message;
        }

        // Проверяем, доступен ли сервис уведомлений
        if (this.$toast && typeof this.$toast.error === 'function') {
          this.$toast.error(errorMsg);
        } else {
          console.error(errorMsg);
        }
      } finally {
        this.isSaving = false;
      }
    },

    removeMaterial(productId) {
      // Удаляем материал из компонентов
      this.techMap.components = this.techMap.components.filter(component =>
        !(component.type === 'product' && component.product_id === productId)
      );

      // Удаляем материал из шагов операций
      this.techMap.components.forEach(component => {
        if (component.type === 'technology' && component.technology?.operations) {
          component.technology.operations.forEach(operation => {
            if (operation.steps) {
              operation.steps = operation.steps.filter(step =>
                !(step.product_id === productId)
              );
            }
          });
        }
      });

      this.products = this.techMap.components?.filter(el => el.type === 'product') || [];
      this.hasUnsavedChanges = true;
    },

    updateMaterialCount(index, newCount) {
      this.techMap.components[index].count = newCount;
      this.hasUnsavedChanges = true;
      this.activeComponent = null;
    },

    removeTechnology(technologyName) {
      console.log('Удаление технологии:', technologyName);

      // Находим индекс технологии для удаления
      const technologyToRemove = this.techMap.components.find(component =>
        component.type === 'technology' && component.technology.name === technologyName
      );

      if (!technologyToRemove) {
        console.error('Технология не найдена:', technologyName);
        return;
      }

      // Запоминаем ID технологии для логирования
      const techId = technologyToRemove.technology_id || technologyToRemove.technology.id;
      console.log('Удаляемая технология:', {
        name: technologyName,
        id: techId,
        operations: technologyToRemove.technology.operations ? technologyToRemove.technology.operations.length : 0
      });

      // Удаляем технологию из компонентов по имени
      this.techMap.components = this.techMap.components.filter(component =>
        !(component.type === 'technology' && component.technology.name === technologyName)
      );

      // Обновляем список технологий
      this.technologies = this.techMap.components?.filter(el => el.type === 'technology') || [];

      // Если удалили текущую выбранную технологию, сбрасываем её
      if (this.selectedTechnology?.technology.name === technologyName) {
        this.selectedTechnology = null;
        this.activeComponent = null;

        // Дополнительно форсируем обновление интерфейса
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }

      // Обязательно отмечаем, что есть несохраненные изменения
      this.hasUnsavedChanges = true;

      console.log('Технология удалена, осталось технологий:', this.technologies.length);
    },

    removeOperation(operationId, technologyId) {
      console.log('removeOperation в TechMap.vue', { operationId, technologyId });

      // Находим технологию в массиве компонентов
      const technology = this.techMap.components.find(el =>
        el.type === 'technology' &&
        (el.technology.id === technologyId || el.technology_id === technologyId)
      );

      if (!technology) {
        console.error('Технология не найдена', technologyId);
        return;
      }

      if (!technology.technology.operations) {
        console.error('Операции отсутствуют в технологии', technology);
        return;
      }

      // Конвертируем ID в строковый формат для надежного сравнения
      const operationIdStr = String(operationId);

      // Находим операцию, которую нужно удалить
      const operationToRemove = technology.technology.operations.find(op => {
        return String(op.id) === operationIdStr ||
              (typeof op.id === 'string' && op.id.includes('local-') && op.id === operationIdStr);
      });

      if (!operationToRemove) {
        console.error('Операция с ID не найдена', operationId);
        console.log('Доступные операции:', technology.technology.operations.map(op => ({
          id: op.id,
          name: op.name,
          isLocal: typeof op.id === 'string' && op.id.includes('local-')
        })));
        return;
      }

      // Запоминаем ID операции для отладки и сравнения
      const opIdToRemove = operationToRemove.id;
      console.log('Удаляем операцию:', {
        id: opIdToRemove,
        name: operationToRemove.name,
        sort: operationToRemove.sort
      });

      // Создаем новый массив операций, исключая удаляемую операцию
      const filteredOperations = technology.technology.operations.filter(op =>
        String(op.id) !== String(opIdToRemove)
      );

      // Создаем копию технологии с обновленным массивом операций
      const updatedTechnology = {
        ...technology,
        technology: {
          ...technology.technology,
          operations: filteredOperations
        }
      };

      // Обновляем технологию в списке компонентов
      const updatedComponents = this.techMap.components.map(comp => {
        if (comp.type === 'technology' &&
          (comp.technology.id === technologyId || comp.technology_id === technologyId)) {
          return updatedTechnology;
        }
        return comp;
      });

      // Обновляем техкарту
      this.techMap = {
        ...this.techMap,
        components: updatedComponents
      };

      // Обновляем список технологий
      this.technologies = this.techMap.components.filter(el => el.type === 'technology');

      // Если удаляется текущая выбранная операция, очищаем выбор
      if (this.selectedOperation && String(this.selectedOperation.id) === String(opIdToRemove)) {
        this.selectedOperation = null;
        this.activeComponent = 'viewDetailTechnology';
      }

      // Если открыта страница просмотра технологии, обновляем данные выбранной технологии
      if (this.activeComponent === 'viewDetailTechnology' && this.selectedTechnology) {
        // Ищем обновленную технологию в списке технологий
        const updatedSelectedTech = this.technologies.find(tech =>
          (tech.technology_id === technologyId || tech.technology.id === technologyId)
        );

        if (updatedSelectedTech) {
          // Обновляем selectedTechnology новым объектом, чтобы triggerить реактивность
          this.selectedTechnology = {...updatedSelectedTech};
          console.log('Обновлена selectedTechnology после удаления операции', {
            techId: technologyId,
            operationsCount: this.selectedTechnology.technology.operations.length
          });

          // Дополнительно форсируем обновление через setTimeout
          setTimeout(() => {
            this.$forceUpdate();
          }, 0);
        }
      }

      this.hasUnsavedChanges = true;
    },

    viewDetailMaterial(id) {
      this.activeComponent = 'viewDetailMaterial';
      this.activeTab = "tab1";
      this.selectedProduct = this.products.find(el => el.product_id == id);
    },

    viewDetailTechnology(name) {
      this.activeComponent = 'viewDetailTechnology';
      this.activeTab = "tab2";
      this.selectedTechnology = this.technologies.find(el => el.technology.name === name);
    },

    viewDetailOperation(id, technologyId) {
      this.activeComponent = 'viewDetailOperation';
      this.activeTab = "tab2";

      console.log('viewDetailOperation вызван:', { id, technologyId });

      // Загружаем список продуктов для модалки выбора продукции
      this.onProductSearch('');

      // Находим технологию
      this.selectedTechnology = this.technologies.find(el =>
        el.technology_id == technologyId || el.technology.id == technologyId
      );

      if (!this.selectedTechnology) {
        console.error('Технология не найдена', {
          technologyId,
          availableTechnologies: this.technologies.map(t => ({
            id: t.technology_id || t.technology.id,
            name: t.technology.name
          }))
        });
        return;
      }

      // Находим операцию по ID
      this.selectedOperation = this.selectedTechnology.technology.operations.find(el => el.id == id);

      if (!this.selectedOperation) {
        console.error('Операция не найдена', {
          id,
          technologyId,
          availableOperations: this.selectedTechnology.technology.operations?.map(op => ({
            id: op.id,
            name: op.name
          })) || []
        });
        return;
      }

      console.log('Найдена операция:', this.selectedOperation);

      // Инициализируем массив шагов, если его нет
      if (!this.selectedOperation.steps) {
        this.selectedOperation.steps = [];
      }
    },

    async moveOperationUp(operationId, technologyId) {
      // Находим индекс технологии
      const technologyIndex = this.techMap.components.findIndex(el =>
        el.type === 'technology' &&
        (el.technology.id === technologyId || el.technology_id === technologyId)
      );

      if (technologyIndex === -1) {
        return;
      }

      const technology = this.techMap.components[technologyIndex];

      if (!technology || !technology.technology.operations) {
        return;
      }

      const operations = technology.technology.operations;
      const currentIndex = operations.findIndex(op => op.id === operationId);

      if (currentIndex <= 0) {
        return;
      }

      const currentOperation = operations[currentIndex];
      const previousOperation = operations[currentIndex - 1];

      if (!currentOperation || !previousOperation) {
        console.error('Операция не найдена');
        return;
      }

      // Инициализируем sort, если он не определен
      if (currentOperation.sort === undefined) currentOperation.sort = currentIndex * 10;
      if (previousOperation.sort === undefined) previousOperation.sort = (currentIndex - 1) * 10;

      // Создаем копии операций с измененными sort
      const updatedCurrentOperation = { ...currentOperation, sort: previousOperation.sort };
      const updatedPreviousOperation = { ...previousOperation, sort: currentOperation.sort };

      // Создаем новый массив операций
      const updatedOperations = [...operations];
      updatedOperations[currentIndex] = updatedCurrentOperation;
      updatedOperations[currentIndex - 1] = updatedPreviousOperation;

      // Сортируем массив по полю sort
      updatedOperations.sort((a, b) => (a.sort || 0) - (b.sort || 0));

      // Создаем обновленную технологию с новым массивом операций
      const updatedTechnology = {
        ...technology,
        technology: {
          ...technology.technology,
          operations: updatedOperations
        }
      };

      // Обновляем компоненты техкарты
      const updatedComponents = [...this.techMap.components];
      updatedComponents[technologyIndex] = updatedTechnology;

      // Обновляем техкарту целиком
      this.techMap = {
        ...this.techMap,
        components: updatedComponents
      };

      // Обновляем список технологий
      this.technologies = this.techMap.components.filter(el => el.type === 'technology');

      // Если перемещается выбранная операция, обновляем её
      if (this.selectedOperation && this.selectedOperation.id === operationId) {
        this.selectedOperation = updatedCurrentOperation;
      }

      // Если открыта страница просмотра технологии, обновляем выбранную технологию
      if (this.activeComponent === 'viewDetailTechnology' && this.selectedTechnology) {
        this.selectedTechnology = this.technologies.find(el =>
          el.technology_id === technologyId || el.technology.id === technologyId
        );

        if (this.selectedTechnology) {
          // Создаем новый объект, чтобы триггерить реактивность
          this.selectedTechnology = {...this.selectedTechnology};
          console.log('Обновлена selectedTechnology после перемещения операции вверх', {
            techId: technologyId,
            operationsCount: this.selectedTechnology.technology.operations.length,
            operations: this.selectedTechnology.technology.operations.map(op => ({
              id: op.id,
              name: op.name,
              sort: op.sort
            }))
          });

          // Дополнительно форсируем обновление через setTimeout
          setTimeout(() => {
            this.$forceUpdate();
          }, 0);
        }
      }

      this.hasUnsavedChanges = true;
    },

    async moveOperationDown(operationId, technologyId) {
      // Находим индекс технологии
      const technologyIndex = this.techMap.components.findIndex(el =>
        el.type === 'technology' &&
        (el.technology.id === technologyId || el.technology_id === technologyId)
      );

      if (technologyIndex === -1) {
        return;
      }

      const technology = this.techMap.components[technologyIndex];

      if (!technology || !technology.technology.operations) {
        return;
      }

      const operations = technology.technology.operations;
      const currentIndex = operations.findIndex(op => op.id === operationId);

      if (currentIndex >= operations.length - 1) {
        return;
      }

      const currentOperation = operations[currentIndex];
      const nextOperation = operations[currentIndex + 1];

      if (!currentOperation || !nextOperation) {
        console.error('Операция не найдена');
        return;
      }

      // Инициализируем sort, если он не определен
      if (currentOperation.sort === undefined) currentOperation.sort = currentIndex * 10;
      if (nextOperation.sort === undefined) nextOperation.sort = (currentIndex + 1) * 10;

      // Создаем копии операций с измененными sort
      const updatedCurrentOperation = { ...currentOperation, sort: nextOperation.sort };
      const updatedNextOperation = { ...nextOperation, sort: currentOperation.sort };

      // Создаем новый массив операций
      const updatedOperations = [...operations];
      updatedOperations[currentIndex] = updatedCurrentOperation;
      updatedOperations[currentIndex + 1] = updatedNextOperation;

      // Сортируем массив по полю sort
      updatedOperations.sort((a, b) => (a.sort || 0) - (b.sort || 0));

      // Создаем обновленную технологию
      const updatedTechnology = {
        ...technology,
        technology: {
          ...technology.technology,
          operations: updatedOperations
        }
      };

      // Обновляем компоненты техкарты
      const updatedComponents = [...this.techMap.components];
      updatedComponents[technologyIndex] = updatedTechnology;

      // Обновляем техкарту целиком
      this.techMap = {
        ...this.techMap,
        components: updatedComponents
      };

      // Обновляем список технологий
      this.technologies = this.techMap.components.filter(el => el.type === 'technology');

      // Если перемещается выбранная операция, обновляем её
      if (this.selectedOperation && this.selectedOperation.id === operationId) {
        this.selectedOperation = updatedCurrentOperation;
      }

      // Если открыта страница просмотра технологии, обновляем выбранную технологию
      if (this.activeComponent === 'viewDetailTechnology' && this.selectedTechnology) {
        this.selectedTechnology = this.technologies.find(el =>
          el.technology_id === technologyId || el.technology.id === technologyId
        );

        if (this.selectedTechnology) {
          // Создаем новый объект, чтобы триггерить реактивность
          this.selectedTechnology = {...this.selectedTechnology};
          console.log('Обновлена selectedTechnology после перемещения операции вниз', {
            techId: technologyId,
            operationsCount: this.selectedTechnology.technology.operations.length,
            operations: this.selectedTechnology.technology.operations.map(op => ({
              id: op.id,
              name: op.name,
              sort: op.sort
            }))
          });

          // Дополнительно форсируем обновление через setTimeout
          setTimeout(() => {
            this.$forceUpdate();
          }, 0);
        }
      }

      this.hasUnsavedChanges = true;
    },

    containsSearchTerm(node) {
      const searchTerm = this.searchQuery.toLowerCase();
      if (node.name && node.name.toLowerCase().includes(searchTerm)) {
        return true;
      }
      if (node.product?.name && node.product.name.toLowerCase().includes(searchTerm)) {
        return true;
      }
      if (node.technology?.name && node.technology.name.toLowerCase().includes(searchTerm)) {
        return true;
      }
      if (node.technology?.operations?.length) {
        for (const operation of node.technology.operations) {
          if (operation.name && operation.name.toLowerCase().includes(searchTerm)) {
            return true;
          }
          if (operation.steps) {
            for (const step of operation.steps) {
              if (step.name && step.name.toLowerCase().includes(searchTerm)) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },

    async handleOptionSelect(option) {
      if (option) {
        this.isModalOpen = true;
        
        // Загружаем продукты при открытии модального окна для материалов
        if (option === 'material') {
          console.log('Загружаем продукты для модального окна...');
          this.onProductSearch('');
        }
      }
    },

    openModal() {
      if (this.selectedChildOption) {
        this.isModalOpen = true;
      }
    },

    closeModal() {
      this.isModalOpen = false;
      this.selectedChildOption = null;
      this.newItemName = '';
      this.selectedTechnologyForOperation = null;
      this.selectedWorkshopPost = null;
      this.addProductError = '';
    },

    getSelectedOptionLabel() {
      const selectedOption = this.addChildOptions.find(option => option.value === this.selectedChildOption);
      return selectedOption ? selectedOption.label : '';
    },

    handleTechnologyChange() {
      console.log('Изменения в технологии');
      this.hasUnsavedChanges = true;
    },

    handleOperationChange() {
      console.log('handleOperationChange вызван');

      // Отмечаем, что есть несохраненные изменения
      this.hasUnsavedChanges = true;

      // Обновляем операцию в списке операций технологии
      if (this.selectedOperation && this.selectedTechnology) {
        console.log('Обновление операции:', this.selectedOperation.id);

        const opIndex = this.selectedTechnology.technology.operations.findIndex(
          op => op.id === this.selectedOperation.id
        );

        if (opIndex !== -1) {
          console.log('Операция найдена в индексе:', opIndex);

          // Заменяем всю операцию на обновленную для обеспечения реактивности
          const updatedOperations = [...this.selectedTechnology.technology.operations];
          updatedOperations[opIndex] = { ...this.selectedOperation };
          this.selectedTechnology.technology.operations = updatedOperations;

          // Также обновляем данные по ссылке
          this.selectedOperation = this.selectedTechnology.technology.operations[opIndex];

          console.log('Операция успешно обновлена');
        } else {
          console.error('Операция не найдена в технологии при обновлении');
        }
      } else {
        console.warn('Нет выбранной операции или технологии для обновления');
      }
    },

    revertChanges() {
      if (!this.hasUnsavedChanges) return;

      this.showCancelConfirmModal();
    },

    // Добавляем методы для работы с модальными окнами подтверждения
    showSaveConfirmModal() {
      this.isSaveConfirmModalOpen = true;
    },

    closeSaveConfirmModal() {
      this.isSaveConfirmModalOpen = false;
    },

    showCancelConfirmModal() {
      this.isCancelConfirmModalOpen = true;
    },

    closeCancelConfirmModal() {
      this.isCancelConfirmModalOpen = false;
    },

    async confirmSave() {
      this.closeSaveConfirmModal();
      await this.saveTechMap();
    },

    confirmCancel() {
      this.closeCancelConfirmModal();
      this.techMap = JSON.parse(JSON.stringify(this.originalTechMap));
      this.products = this.techMap.components?.filter(el => el.type === 'product') || [];
      this.technologies = this.techMap.components?.filter(el => el.type === 'technology') || [];
      this.hasUnsavedChanges = false;

      // Проверяем, существует ли сервис уведомлений перед использованием
      if (this.$toast && typeof this.$toast.info === 'function') {
        this.$toast.info('Изменения отменены');
      } else {
        console.log('Изменения отменены');
      }
    }
  }
};
</script>
